var _dec, _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { assert } from '@ember/debug';
import { computed } from '@ember/object';
import { PromiseObject } from './promise-proxy-base';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

const Extended = PromiseObject;

/**
 @module @ember-data/model
 */

/**
  A PromiseBelongsTo is a PromiseObject that also proxies certain method calls
  to the underlying belongsTo model.
  Right now we proxy:
    * `reload()`
  @class PromiseBelongsTo
  @extends PromiseObject
  @private
*/
let PromiseBelongsTo = (_dec = computed(), (_class = class PromiseBelongsTo extends Extended {
  // we don't proxy meta because we would need to proxy it to the relationship state container
  //  however, meta on relationships does not trigger change notifications.
  //  if you need relationship meta, you should do `record.belongsTo(relationshipName).meta()`
  get meta() {
    // eslint-disable-next-line no-constant-condition
    if (1) {
      assert('You attempted to access meta on the promise for the async belongsTo relationship ' + `${this.get('_belongsToState').modelName}:${this.get('_belongsToState').key}'.` + '\nUse `record.belongsTo(relationshipName).meta()` instead.', false);
    }
    return;
  }
  async reload(options) {
    assert('You are trying to reload an async belongsTo before it has been created', this.content !== undefined);
    let {
      key,
      legacySupport
    } = this._belongsToState;
    await legacySupport.reloadBelongsTo(key, options);
    return this;
  }
}, (_applyDecoratedDescriptor(_class.prototype, "meta", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "meta"), _class.prototype)), _class));
export default PromiseBelongsTo;